import React, { useEffect, useState, useRef } from 'react';
import Sortable from 'sortablejs';

import { useMedia } from 'react-use';
import { showToast } from '../../shared/Toast';
import { CurrentUser } from '../../calendar/Calendar';
import {
  fromRole,
  isExpired,
  ProjectModel,
  SbCurrentUser,
  SbStatusMaster,
  SubmissionBoardModel,
} from '../component/SbModel';
import SbDetailCard from '../component/SbDetailCard';
import ParticipantItem from '../../search/ParticipantItem';
import { SbProfileListItem } from './SbProfileListItem';
import SbProfileDetail from '../recipient/SbProfileDetail';
import AllProfiles from './AllProfiles';
import InvitePerformer from './InvitePerformer';
import submissionBoardService from '../../services/SubmissionBoardService';

// import {
//   Bars2Icon,
//   PlusIcon,
//   UserPlusIcon,
//   Squares2X2Icon,
//   ListBulletIcon,
//   PencilIcon,
// } from '@heroicons/react/24/outline';
import Button from '../component/Button';
import { ArrowUpRightIcon, CheckIcon, EllipsisVerticalIcon, LayoutGridIcon, LayoutListIcon, LockIcon, LockOpenIcon, PencilLineIcon, PenLineIcon, PlusIcon, TrafficCone } from 'lucide-react';
import CustomTabs from '../component/CustomTabs';
import { Menu } from '@headlessui/react';
import MenuItemCustom from '../component/MenuItemCustom';
import { useIsMobile } from '../component/useIsMobile';
interface SbDetailsProps {
  fromScreen: string;
  indexRow: number;
  currentUser: SbCurrentUser;
  project: ProjectModel;
  submissionBoardModel: SubmissionBoardModel;
  // key_token?: string;
  // otp_valid?: string;
  sb_recipient?: any;
  dialogCloseHandler?: (open: boolean) => void;
  refreshSubmissionBoard?: () => void;
  updateSubmissionBoardCounts?: (
    sbId: number,
    profileStatusChange: {
      type: 'add' | 'remove' | 'status_change';
      oldStatus?: number;
      newStatus?: number;
    }
  ) => void;
  editSb: (index: number) => void;
}

// For SB details for SB creator
export default function SbDetailsListItem({
  fromScreen,
  currentUser,
  project,
  submissionBoardModel,
  // key_token,
  // otp_valid,
  sb_recipient,
  dialogCloseHandler,
  refreshSubmissionBoard,
  updateSubmissionBoardCounts,
  indexRow,
  editSb,
}: SbDetailsProps) {
  const [selectedSubmissionBoard, setSelectedSubmissionBoard] =
    useState<SubmissionBoardModel | null>(null);
  const [isSbLocked, setIsSbLocked] = useState(false);
  const [showProfileDetails, setShowProfileDetails] = useState(null);

  const [currentProfileIndex, setCurrentProfileIndex] = useState(0);
  const [addMoreProfiles, setAddMoreProfiles] = useState(false);
  const [showInvitePerformer, setShowInvitePerformer] = useState(false);
  const sortableRef = useRef<HTMLDivElement>(null);
  const sortableInstance = useRef<Sortable | null>(null);

  const isMobile = useIsMobile();
  const is400_639Screen = useMedia('(min-width: 400px) and (max-width: 639px)', false);
  const [viewMode, setViewMode] = useState<'grid' | 'list'>('grid');

  const [tabSelected, setTabSelected] = useState<number>(1);
  const [tabs, setTabs] = useState([]);
  const [showList, setShowList] = useState(false);
  const [menuOpenUpward, setMenuOpenUpward] = useState(false);
  const menuButtonRef = useRef(null);

  useEffect(() => {
    let _tabs = [];
    const is_xs = window.innerWidth > 1 && window.innerWidth < 639; // useMedia('(min-width: 1px) and (max-width: 639px)', false);
    if (is_xs) {
      _tabs.push({ id: 1, name: 'Profiles', show: true });
      _tabs.push({ id: 2, name: 'Information', show: true });
    } else {
      _tabs.push({ id: 1, name: 'Shortlisted Profiles', show: true });
      _tabs.push({ id: 2, name: 'Role Information', show: true });
    }
    setTabs(_tabs);
  }, []);
  useEffect(() => {
    if (
      submissionBoardModel.sb_status == SbStatusMaster.expired ||
      submissionBoardModel.sb_status == SbStatusMaster.locked ||
      isExpired(submissionBoardModel?.expire_at)
    ) {
      setIsSbLocked(true);
    } else {
      setIsSbLocked(false);
    }
    setSelectedSubmissionBoard(submissionBoardModel);
  }, [submissionBoardModel]);

  useEffect(() => {
    if (selectedSubmissionBoard != null) {
      console.log('selectedSubmissionBoard.profiles', selectedSubmissionBoard.profiles);
    }
    const fetchRecipientForSB = async () => {
      try {
        const sb_recipients = await submissionBoardService.getSbRecipients(
          project.uuid,
          selectedSubmissionBoard.id
        );
        if (sb_recipients && sb_recipients.length > 0) {
          selectedSubmissionBoard.recipients = sb_recipients;
          // setRecipients(sb_recipients);
        } else {
          selectedSubmissionBoard.recipients = [];
          //          setRecipients([]);
        }
      } catch (error) {
        showToast('Error while getting submission boards.', 'danger');
      } finally {
      }
    };

    if (selectedSubmissionBoard != null && selectedSubmissionBoard.recipients == undefined) {
      fetchRecipientForSB();
    }
  }, [selectedSubmissionBoard]);

  useEffect(() => {
    console.log('currentProfileIndex', currentProfileIndex);
    if (selectedSubmissionBoard != null && currentProfileIndex != null) {
      setShowProfileDetails(selectedSubmissionBoard.profiles[currentProfileIndex]);
    }
  }, [currentProfileIndex]);

  useEffect(() => {
    if (sortableRef.current && !isSbLocked && selectedSubmissionBoard) {
      // Initialize Sortable
      sortableInstance.current = Sortable.create(sortableRef.current, {
        animation: 150,
        ghostClass: 'opacity-50',
        dragClass: 'opacity-75',
        handle: '.drag-handle',
        onEnd: async (evt) => {
          if (evt.oldIndex !== evt.newIndex) {
            await handleReorder(evt.oldIndex!, evt.newIndex!);
          }
        },
      });
    }
    return () => {
      if (sortableInstance.current) {
        sortableInstance.current.destroy();
        sortableInstance.current = null;
      }
    };
  }, [isSbLocked, selectedSubmissionBoard?.profiles]);

  const handleReorder = async (oldIndex: number, newIndex: number) => {
    try {
      // Create new array with reordered items
      const profiles = [...selectedSubmissionBoard.profiles];
      const [movedProfile] = profiles.splice(oldIndex, 1);
      profiles.splice(newIndex, 0, movedProfile);
      // Extract profile IDs in new order
      const profileIds = profiles.map((profile) => profile.id);
      // Call API to update order on backend
      await submissionBoardService.reorderPerformer(
        project.uuid,
        selectedSubmissionBoard.id,
        profileIds
      );
      // Refresh the profiles to reflect new order
      // if (fetchProfilesForSB) {
      //   await fetchProfilesForSB();
      // }
      if (refreshSubmissionBoard) {
        refreshSubmissionBoard();
      }
      showToast('Profiles reordered successfully', 'success');
    } catch (error) {
      console.error('Error reordering profiles:', error);
      showToast('Failed to reorder profiles', 'danger');
      if (refreshSubmissionBoard) {
        refreshSubmissionBoard();
      }
      // Refresh to restore original order on error
      // if (fetchProfilesForSB) {
      //   await fetchProfilesForSB();
      // }
    }
  };
  const onCloseDialog = (value: boolean) => {
    dialogCloseHandler(value);
  };
  const submitForReviewClickHandler = async () => {
    await submitForReviewWeb();
  };
  const submitForReviewWeb = async () => {
    try {
      await submissionBoardService.sendSbForReviewToRecipients(
        project.uuid,
        selectedSubmissionBoard.id
      );
      showToast('Sent submission boards details to recipients.', 'success');
    } catch (error) {
      showToast('Error while fetching submission boards.', 'danger');
    } finally {
    }
  };

  const invitePerformerClickHandler = () => {
    if (fromScreen == fromRole.SB_CREATOR) {
      setShowInvitePerformer(true);
    }
  };
  const addMoreProfilsClickHandler = () => {
    if (fromScreen == fromRole.SB_CREATOR) {
      setAddMoreProfiles(true);
    }
  };
  const getSBCreatorName = () => {
    const owner_name = submissionBoardModel.owner_name;
    const super_coordinator_name = submissionBoardModel.super_coordinator_name;
    if (owner_name) {
      return (
        <div className="font-normal text-base">
          <span className="font-bold text-base">{owner_name}</span>{' '}
          {'has prepared talent submissions for:'}
        </div>
      );
    }
    if (super_coordinator_name) {
      return (
        <div className="font-normal text-base">
          <span className="font-bold text-base">{super_coordinator_name}</span>{' '}
          {'has prepared talent submissions for:'}
        </div>
      );
    }
    return <div className="font-normal text-base">Talent submissions for:</div>;
  };
  const handleLockSb = async (sb_status: string) => {
    if (!selectedSubmissionBoard) return;
    try {
      await submissionBoardService.updateStatusSubmissionBoard(project, selectedSubmissionBoard, {
        sb_status: sb_status,
      });
      if (sb_status == SbStatusMaster.open) {
        showToast('Successfully unlocked ' + submissionBoardModel.title, 'success');
        setIsSbLocked(false);
      } else if (sb_status == SbStatusMaster.locked) {
        showToast('Successfully locked ' + submissionBoardModel.title, 'success');
        setIsSbLocked(true);
      }

      if (refreshSubmissionBoard) {
        refreshSubmissionBoard();
      }
    } catch (error) {
      console.error('Failed to lock SB:', error);
      showToast('Failed to lock ' + submissionBoardModel.title, 'danger');
    }
  };

  const checkMenuPosition = () => {
    if (menuButtonRef.current) {
      const rect = menuButtonRef.current.getBoundingClientRect();
      const menuHeight = 300; // Approximate height of the menu
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;
      
      // If not enough space below but enough space above, open upward
      setMenuOpenUpward(spaceBelow < menuHeight && spaceAbove > menuHeight);
    } else {
      setTimeout(() => {
        checkMenuPosition();
      }, 1000);
    }
  };
  const actionMenu = (showSeparator:boolean) => {
    return (
      <>
        {fromScreen === fromRole.SB_CREATOR && (
          <>
            {showSeparator && (
              <div
                className="border border-gray-200"
                style={{
                  width: '1px',
                  height: '-webkit-fill-available',
                  maxHeight: '2.625rem',
                }}
              ></div>
            )}
            {true && (
              <div
                className="flex justify-end"
              >
                <Menu as="div" className="relative inline-block text-left flex w-full">
                  <Menu.Button
                    id="layout_sort_id"
                    className={`flex items-center justify-center rounded-md px-4 py-2 gap-x-2.5 flex-row border border-gray-300 bg-white box-shadow-100 text-sm font-semibold text-gray-600 hover:text-black`}
                    onClick={checkMenuPosition}
                  >
                    <div className="w-6 h-6 p-3px flex items-center justify-center">
                      <EllipsisVerticalIcon className="w-4-2 h-4-2" aria-hidden="true" />
                    </div>
                  </Menu.Button>

                  <Menu.Items className={`absolute flex flex-col w-56 -right-5 ${menuOpenUpward ? 'bottom-12 origin-bottom-right' : 'mt-12 origin-top-right'} focus:outline-none z-10`}>
                    <div
                      className="absolute right-2 text-gray-300 text-center items-center flex w-4 h-4"
                      style={{
                        zIndex: 51,
                        [menuOpenUpward ? 'bottom' : 'top']: '-0.625rem',
                        right: '2.5rem',
                        width: '1rem',
                      }}
                    >
                      <div

                        className={`absolute right-0 w-4 h-4 border-gray-300 transform bg-white ${menuOpenUpward
                          ? 'border-b-2 border-r-2 rotate-45'
                          : 'border-t-2 border-l-2 rotate-45'
                          }`}
                        style={{
                          zIndex: 51,
                          [menuOpenUpward ? 'bottom' : 'top']: '0.125rem',
                        }}
                      />
                    </div>

                    <div className="flex flex-col w-full rounded-md py-1 px-1 gap-1 border-gray-300 border bg-white box-shadow-100 ring-1 ring-black ring-opacity-5 ">
                      {!isSbLocked && fromScreen == fromRole.SB_CREATOR && (
                        <>
                          <MenuItemCustom
                            name={'Add Talent From Filmik'}
                            icon={
                              <div className="w-4 h-4 ">
                                <PlusIcon className="w-4 h-4" />
                              </div>
                            }
                            selectedHandler={function (): void {
                              addMoreProfilsClickHandler();
                            }}
                          />
                          <MenuItemCustom
                            name={'Invite New Talent'}
                            icon={
                              <div className="w-4 h-4 ">
                                <PlusIcon className="w-4 h-4" />
                              </div>
                            }
                            selectedHandler={function (): void {
                              invitePerformerClickHandler();
                            }}
                          />
                          <hr className="w-full " />
                        </>
                      )}
                      <MenuItemCustom
                        name={'Edit Board'}
                        icon={
                          <div className="w-4 h-4 ">
                            <PencilLineIcon className="w-4 h-4" />
                          </div>
                        }
                        selectedHandler={function (): void {
                          if (editSb) {
                            editSb(indexRow);
                          }
                        }}
                      />
                      {!isSbLocked ? (
                        <MenuItemCustom
                          name={'Lock Board'}
                          icon={
                            <div className="w-4 h-4 ">
                              <LockIcon className="w-4 h-4" />
                            </div>
                          }
                          selectedHandler={function (): void {
                            handleLockSb(SbStatusMaster.locked);
                          }}
                        />
                      ) : (
                        <MenuItemCustom
                          name={'Unlock Board'}
                          icon={
                            <div className="w-4 h-4 ">
                              <LockOpenIcon className="w-4 h-4" />
                            </div>
                          }
                          selectedHandler={function (): void {
                            handleLockSb(SbStatusMaster.pending_review);
                          }}
                        />
                      )}
                      {!isSbLocked && fromScreen == fromRole.SB_CREATOR &&
                        selectedSubmissionBoard.recipients &&
                        selectedSubmissionBoard.recipients.length > 0 &&
                        (
                          <>
                            <hr className="w-full " />
                            <MenuItemCustom
                              name={'Submit Board'}
                              type='button-primary'
                              icon={
                                <div className="w-4 h-4 ">
                                  <ArrowUpRightIcon className="w-4 h-4" />
                                </div>
                              }
                              selectedHandler={function (): void {
                                submitForReviewClickHandler();
                              }}
                            />
                          </>
                        )}
                    </div>
                  </Menu.Items>
                </Menu>
              </div>
            )}
          </>
        )}
      </>
    );
  }
  return (
    <>
      <div className="overflow-visible justify-items-center">
        {selectedSubmissionBoard != null && (
          <>
            {true && (
              <div className="mt-1 flex flex-col w-full p-2 px:4 sm:px-9 gap-6 mx-auto max-w-screen-xl">
                <div className="flex flex-col sm:flex-row border-b  gap-2 justify-between items-center pr-14"
                ref={menuButtonRef}
                >
                  <div className=" w-full flex flex-row justify-between items-center">
                    <div className="flex flex-row items-center">
                      <CustomTabs
                        tabSelected={tabSelected}
                        tabs={tabs}
                        tabSelectHandler={(id: number) => setTabSelected(id)}
                      />
                    </div>
                    {isMobile && <div className="flex sm:hidden ">{actionMenu(false)}</div>}
                  </div>
                  {!isMobile && <div className="gap-4 hidden sm:flex">
                    <Button
                      id="layout_grid_id"
                      variant="secondary"
                      btn_size="small"
                      className={`${viewMode === 'grid'
                        ? 'bg-indigo-50 text-blue-500'
                        : 'text-gray-600 hover:text-black'
                        }`}
                      onClick={() => {
                        setViewMode('grid');
                      }}
                    >
                      <div className="w-6 h-6 p-3px flex items-center justify-center">
                        <LayoutGridIcon className="w-4-2 h-4-2" aria-hidden="true" />
                      </div>
                    </Button>
                    <Button
                      id="layout_list_id"
                      variant="secondary"
                      btn_size="small"
                      className={`${viewMode === 'list'
                        ? 'bg-indigo-50 text-blue-500'
                        : 'text-gray-600 hover:text-black'
                        }`}
                      onClick={() => {
                        setViewMode('list');
                      }}
                    >
                      <div className="w-6 h-6 p-3px flex items-center justify-center">
                        <LayoutListIcon className="w-4-2 h-4-2" aria-hidden="true" />
                      </div>
                    </Button>
                    {/* Action Menu */}
                    {actionMenu(true)}
                    {/* Action Menu */}
                  </div> }
                </div>

                {tabSelected == 1 && (
                  <>
                    {/* {!isSbLocked && fromScreen == fromRole.SB_CREATOR && (
                      <div className='className="flex flex-1 justify-end items-center gap-2-1pr-2-1 border-r border-gray-200"'>
                        <div className="flex items-center justify-end gap-2-1">
                          <div className="text-sm font-normal">Add Talent:</div>
                          <Button
                            id="addmore_profiles_sb_btn_id"
                            variant="secondary"
                            btn_size="small"
                            className="cursor-pointer"
                            onClick={() => {
                              addMoreProfilsClickHandler();
                            }}
                          >
                            From Filmik
                          </Button>
                          <Button
                            id="invite_profile_sb_btn_id"
                            variant="secondary"
                            btn_size="small"
                            className="cursor-pointer"
                            onClick={() => {
                              invitePerformerClickHandler();
                            }}
                          >
                            Invite New
                          </Button>
                        </div>
                      </div>
                    )} */}
                    {selectedSubmissionBoard != null &&
                      selectedSubmissionBoard.profiles != null &&
                      selectedSubmissionBoard.profiles.length > 0 ? (
                      <div
                        ref={sortableRef}
                        className={
                          viewMode === 'grid' && !isMobile
                            ? (is400_639Screen ? 'px-0' : 'p-0') +
                            '  grid grid-cols-1 md:grid-cols-3  gap-5 items-start '
                            : 'flex flex-col gap-5'
                        }
                        id="list_active"
                      >
                        {viewMode === 'grid' && !isMobile ?
                          [0, 1, 2].map((itemNumber) => {
                            return <>
                              <div
                                className={
                                  viewMode === 'grid'
                                    ? (is400_639Screen ? 'px-0' : 'p-0') +
                                    ' flex flex-col gap-5 '
                                    : 'flex flex-col gap-5'
                                }
                              >
                                {selectedSubmissionBoard != null &&
                                  selectedSubmissionBoard.profiles.map((profileUser, index) => {
                                    if (viewMode === 'grid' && index % 3 !== itemNumber) {
                                      return <></>;
                                    }
                                    return (
                                      <div
                                        key={profileUser.id}
                                        className="relative justify-items-center sm:justify-items-stretch h-full"
                                      >
                                        <SbProfileListItem
                                          currentUser={currentUser}
                                          submissionBoardModel={selectedSubmissionBoard}
                                          // key_token={key_token}
                                          // otp_valid={otp_valid}
                                          project={project}
                                          profileUser={profileUser}
                                          fromScreen={fromScreen}
                                          sb_recipient={sb_recipient}
                                          viewMode={viewMode}
                                          // showProfileDetailInModal={showProfileDetails}
                                          refreshSubmissionBoard={() => {
                                            if (refreshSubmissionBoard) {
                                              refreshSubmissionBoard();
                                            }
                                          }}
                                          updateSubmissionBoardCounts={updateSubmissionBoardCounts}
                                          // profileRemoved={(submissionBoardModel: any, userProfile: any) => {
                                          //   if (profileRemoved) {
                                          //     profileRemoved(submissionBoardModel, userProfile);
                                          //   }
                                          // }}
                                          profileIndex={index}
                                          prevNextProfile={(value: number, profileIndex: number) => {
                                            if (value == -1 && profileIndex - 1 >= 0) {
                                              setCurrentProfileIndex(profileIndex - 1);
                                            } else if (
                                              value == 1 &&
                                              profileIndex + 1 < selectedSubmissionBoard.profiles.length
                                            ) {
                                              setCurrentProfileIndex(profileIndex + 1);
                                            } else if (value == 0) {
                                              if (profileIndex == currentProfileIndex) {
                                                if (
                                                  selectedSubmissionBoard != null &&
                                                  currentProfileIndex != null
                                                ) {
                                                  setShowProfileDetails(
                                                    selectedSubmissionBoard.profiles[currentProfileIndex]
                                                  );
                                                }
                                              } else {
                                                setCurrentProfileIndex(profileIndex);
                                              }
                                            }
                                          }}
                                        />
                                      </div>
                                    );
                                  })}
                              </div>
                            </>;
                          }) : <>
                            {selectedSubmissionBoard != null &&
                              selectedSubmissionBoard.profiles.map((profileUser, index) => {

                                return (
                                  <div
                                    key={profileUser.id}
                                    className="relative justify-items-center sm:justify-items-stretch h-full"
                                  >
                                    <SbProfileListItem
                                      currentUser={currentUser}
                                      submissionBoardModel={selectedSubmissionBoard}
                                      // key_token={key_token}
                                      // otp_valid={otp_valid}
                                      project={project}
                                      profileUser={profileUser}
                                      fromScreen={fromScreen}
                                      sb_recipient={sb_recipient}
                                      viewMode={isMobile ? 'grid' : viewMode}
                                      // showProfileDetailInModal={showProfileDetails}
                                      refreshSubmissionBoard={() => {
                                        if (refreshSubmissionBoard) {
                                          refreshSubmissionBoard();
                                        }
                                      }}
                                      updateSubmissionBoardCounts={updateSubmissionBoardCounts}
                                      // profileRemoved={(submissionBoardModel: any, userProfile: any) => {
                                      //   if (profileRemoved) {
                                      //     profileRemoved(submissionBoardModel, userProfile);
                                      //   }
                                      // }}
                                      profileIndex={index}
                                      prevNextProfile={(value: number, profileIndex: number) => {
                                        if (value == -1 && profileIndex - 1 >= 0) {
                                          setCurrentProfileIndex(profileIndex - 1);
                                        } else if (
                                          value == 1 &&
                                          profileIndex + 1 < selectedSubmissionBoard.profiles.length
                                        ) {
                                          setCurrentProfileIndex(profileIndex + 1);
                                        } else if (value == 0) {
                                          if (profileIndex == currentProfileIndex) {
                                            if (
                                              selectedSubmissionBoard != null &&
                                              currentProfileIndex != null
                                            ) {
                                              setShowProfileDetails(
                                                selectedSubmissionBoard.profiles[currentProfileIndex]
                                              );
                                            }
                                          } else {
                                            setCurrentProfileIndex(profileIndex);
                                          }
                                        }
                                      }}
                                    />
                                  </div>
                                );
                              })}
                          </>
                        }
                      </div>
                    ) : (
                      <div className="flex flex-col w-full h-full items-center justify-center py-32">
                        <div className="flex flex-col items-center gap-4">
                          {/* Traffic Cone Icon */}
                          <div className="flex items-center justify-center">
                            <TrafficCone className="w-16 h-16 text-gray-300" />
                          </div>
                          {/* Headline */}
                          <div className="text-xl font-semibold text-gray-700">
                            No Talent Added Yet
                          </div>
                          {/* Body Text */}
                          <div className="flex flex-col items-center gap-1 text-center text-gray-400">
                            <div>Looks like you haven't shortlisted any candidates.</div>
                            <div>Once you do, they'll show up right here.</div>
                          </div>
                           <div className="flex  items-center justify-center">
                              <Button
                                id="create_sb_add_talent_btn_id"
                                className=""
                                variant="primary"
                                btn_size="small"
                                onClick={addMoreProfilsClickHandler}
                              >
                                <div className="w-6 h-6  flex items-center justify-center">
                                  <PlusIcon className="w-4-2 h-4-2" />
                                </div>
                                Add Talent From Filmik
                              </Button>
                            </div>
                        </div>
                      </div>
                    )}
                      {/* <div
                        className={
                          viewMode === 'grid'
                            ? (is400_639Screen ? 'px-0' : 'p-0') +
                              ' border border-red-900 grid grid-cols-1  gap-5 items-stretch '
                            : 'flex flex-col gap-5'
                        }
                        id="list_active"
                      >
                        {selectedSubmissionBoard != null &&
                          selectedSubmissionBoard.profiles.map((profileUser, index) => {
                            if(index % 3 !== 0) {
                              return <></>;
                            }
                            return (
                              <div
                                key={profileUser.id}
                                className="relative justify-items-center sm:justify-items-stretch h-full"
                              >
                                <SbProfileListItem
                                  currentUser={currentUser}
                                  submissionBoardModel={selectedSubmissionBoard}
                                  // key_token={key_token}
                                  // otp_valid={otp_valid}
                                  project={project}
                                  profileUser={profileUser}
                                  fromScreen={fromScreen}
                                  sb_recipient={sb_recipient}
                                  viewMode={viewMode}
                                  // showProfileDetailInModal={showProfileDetails}
                                  refreshSubmissionBoard={() => {
                                    if (refreshSubmissionBoard) {
                                      refreshSubmissionBoard();
                                    }
                                  }}
                                  updateSubmissionBoardCounts={updateSubmissionBoardCounts}
                                  // profileRemoved={(submissionBoardModel: any, userProfile: any) => {
                                  //   if (profileRemoved) {
                                  //     profileRemoved(submissionBoardModel, userProfile);
                                  //   }
                                  // }}
                                  profileIndex={index}
                                  prevNextProfile={(value: number, profileIndex: number) => {
                                    if (value == -1 && profileIndex - 1 >= 0) {
                                      setCurrentProfileIndex(profileIndex - 1);
                                    } else if (
                                      value == 1 &&
                                      profileIndex + 1 < selectedSubmissionBoard.profiles.length
                                    ) {
                                      setCurrentProfileIndex(profileIndex + 1);
                                    } else if (value == 0) {
                                      if (profileIndex == currentProfileIndex) {
                                        if (
                                          selectedSubmissionBoard != null &&
                                          currentProfileIndex != null
                                        ) {
                                          setShowProfileDetails(
                                            selectedSubmissionBoard.profiles[currentProfileIndex]
                                          );
                                        }
                                      } else {
                                        setCurrentProfileIndex(profileIndex);
                                      }
                                    }
                                  }}
                                />
                              </div>
                            );
                          })}
                      </div>
                      <div
                        className={
                          viewMode === 'grid'
                            ? (is400_639Screen ? 'px-0' : 'p-0') +
                              ' border-green-900 border grid grid-cols-1  gap-5 items-stretch '
                            : 'flex flex-col gap-5'
                        }
                        id="list_active"
                      >
                        {selectedSubmissionBoard != null &&
                          selectedSubmissionBoard.profiles.map((profileUser, index) => {
                            if(index % 3 !== 1) {
                              return <></>;
                            }
                            return (
                              <div
                                key={profileUser.id}
                                className="relative justify-items-center sm:justify-items-stretch h-full"
                              >
                                <SbProfileListItem
                                  currentUser={currentUser}
                                  submissionBoardModel={selectedSubmissionBoard}
                                  // key_token={key_token}
                                  // otp_valid={otp_valid}
                                  project={project}
                                  profileUser={profileUser}
                                  fromScreen={fromScreen}
                                  sb_recipient={sb_recipient}
                                  viewMode={viewMode}
                                  // showProfileDetailInModal={showProfileDetails}
                                  refreshSubmissionBoard={() => {
                                    if (refreshSubmissionBoard) {
                                      refreshSubmissionBoard();
                                    }
                                  }}
                                  updateSubmissionBoardCounts={updateSubmissionBoardCounts}
                                  // profileRemoved={(submissionBoardModel: any, userProfile: any) => {
                                  //   if (profileRemoved) {
                                  //     profileRemoved(submissionBoardModel, userProfile);
                                  //   }
                                  // }}
                                  profileIndex={index}
                                  prevNextProfile={(value: number, profileIndex: number) => {
                                    if (value == -1 && profileIndex - 1 >= 0) {
                                      setCurrentProfileIndex(profileIndex - 1);
                                    } else if (
                                      value == 1 &&
                                      profileIndex + 1 < selectedSubmissionBoard.profiles.length
                                    ) {
                                      setCurrentProfileIndex(profileIndex + 1);
                                    } else if (value == 0) {
                                      if (profileIndex == currentProfileIndex) {
                                        if (
                                          selectedSubmissionBoard != null &&
                                          currentProfileIndex != null
                                        ) {
                                          setShowProfileDetails(
                                            selectedSubmissionBoard.profiles[currentProfileIndex]
                                          );
                                        }
                                      } else {
                                        setCurrentProfileIndex(profileIndex);
                                      }
                                    }
                                  }}
                                />
                              </div>
                            );
                          })}
                      </div>
                      <div
                        className={
                          viewMode === 'grid'
                            ? (is400_639Screen ? 'px-0' : 'p-0') +
                              ' border-blue-900 border grid grid-cols-1  gap-5 items-stretch '
                            : 'flex flex-col gap-5'
                        }
                        id="list_active"
                      >
                        {selectedSubmissionBoard != null &&
                          selectedSubmissionBoard.profiles.map((profileUser, index) => {
                            if(index % 3 !== 2) {
                              return <></>;
                            }
                            return (
                              <div
                                key={profileUser.id}
                                className="relative justify-items-center sm:justify-items-stretch h-full"
                              >
                                <SbProfileListItem
                                  currentUser={currentUser}
                                  submissionBoardModel={selectedSubmissionBoard}
                                  // key_token={key_token}
                                  // otp_valid={otp_valid}
                                  project={project}
                                  profileUser={profileUser}
                                  fromScreen={fromScreen}
                                  sb_recipient={sb_recipient}
                                  viewMode={viewMode}
                                  // showProfileDetailInModal={showProfileDetails}
                                  refreshSubmissionBoard={() => {
                                    if (refreshSubmissionBoard) {
                                      refreshSubmissionBoard();
                                    }
                                  }}
                                  updateSubmissionBoardCounts={updateSubmissionBoardCounts}
                                  // profileRemoved={(submissionBoardModel: any, userProfile: any) => {
                                  //   if (profileRemoved) {
                                  //     profileRemoved(submissionBoardModel, userProfile);
                                  //   }
                                  // }}
                                  profileIndex={index}
                                  prevNextProfile={(value: number, profileIndex: number) => {
                                    if (value == -1 && profileIndex - 1 >= 0) {
                                      setCurrentProfileIndex(profileIndex - 1);
                                    } else if (
                                      value == 1 &&
                                      profileIndex + 1 < selectedSubmissionBoard.profiles.length
                                    ) {
                                      setCurrentProfileIndex(profileIndex + 1);
                                    } else if (value == 0) {
                                      if (profileIndex == currentProfileIndex) {
                                        if (
                                          selectedSubmissionBoard != null &&
                                          currentProfileIndex != null
                                        ) {
                                          setShowProfileDetails(
                                            selectedSubmissionBoard.profiles[currentProfileIndex]
                                          );
                                        }
                                      } else {
                                        setCurrentProfileIndex(profileIndex);
                                      }
                                    }
                                  }}
                                />
                              </div>
                            );
                          })}
                      </div> */}
                    {false && <div
                      ref={sortableRef}
                      className={
                        viewMode === 'grid'
                          ? (is400_639Screen ? 'px-0' : 'p-0') +
                          ' grid grid-cols-1 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-3 gap-5 items-stretch '
                          : 'flex flex-col gap-5'
                      }
                      id="list_active"
                    >
                      {selectedSubmissionBoard != null &&
                        selectedSubmissionBoard.profiles.map((profileUser, index) => {
                          return (
                            <div
                              key={profileUser.id}
                              className="relative justify-items-center sm:justify-items-stretch h-full"
                            >
                              <SbProfileListItem
                                currentUser={currentUser}
                                submissionBoardModel={selectedSubmissionBoard}
                                // key_token={key_token}
                                // otp_valid={otp_valid}
                                project={project}
                                profileUser={profileUser}
                                fromScreen={fromScreen}
                                sb_recipient={sb_recipient}
                                viewMode={viewMode}
                                // showProfileDetailInModal={showProfileDetails}
                                refreshSubmissionBoard={() => {
                                  if (refreshSubmissionBoard) {
                                    refreshSubmissionBoard();
                                  }
                                }}
                                updateSubmissionBoardCounts={updateSubmissionBoardCounts}
                                // profileRemoved={(submissionBoardModel: any, userProfile: any) => {
                                //   if (profileRemoved) {
                                //     profileRemoved(submissionBoardModel, userProfile);
                                //   }
                                // }}
                                profileIndex={index}
                                prevNextProfile={(value: number, profileIndex: number) => {
                                  if (value == -1 && profileIndex - 1 >= 0) {
                                    setCurrentProfileIndex(profileIndex - 1);
                                  } else if (
                                    value == 1 &&
                                    profileIndex + 1 < selectedSubmissionBoard.profiles.length
                                  ) {
                                    setCurrentProfileIndex(profileIndex + 1);
                                  } else if (value == 0) {
                                    if (profileIndex == currentProfileIndex) {
                                      if (
                                        selectedSubmissionBoard != null &&
                                        currentProfileIndex != null
                                      ) {
                                        setShowProfileDetails(
                                          selectedSubmissionBoard.profiles[currentProfileIndex]
                                        );
                                      }
                                    } else {
                                      setCurrentProfileIndex(profileIndex);
                                    }
                                  }
                                }}
                              />
                            </div>
                          );
                        })}
                    </div>}
                  </>
                )}
                {tabSelected == 2 && (
                  <>
                    <div className="w-full mx-auto flex flex-col gap-14 pt-5 pr-10 pb-10 pl-10 flex-shrink-0">
                      <SbDetailCard
                        indexRow={indexRow}
                        fromScreen={fromScreen}
                        project={project}
                        submissionBoardModel={selectedSubmissionBoard}
                        refreshSubmissionBoard={() => {
                          if (refreshSubmissionBoard) {
                            refreshSubmissionBoard();
                          }
                        }}
                        editSb={function (index: number): void {
                          if (editSb) {
                            editSb(indexRow);
                          }
                        }}
                        submitForReview={submitForReviewClickHandler}
                        isSbClosed={isSbLocked}
                      ></SbDetailCard>
                      <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-10">
                        <div className="flex flex-col gap-5">
                          <div className="text-2xl font-semibold text-left">
                            <span>Board Notes</span>
                          </div>
                          <div className="flex flex-col gap-5 py-7 pr-7 pl-5 bg-blue-50 border-l-8 border-blue-400 text-sm text-gray-700 rounded-lg overflow-y-auto h-80 border rounded-lg">
                            <div>{getSBCreatorName()}</div>
                            <div>
                              <div className="font-normal text-xs">Role</div>
                              <div className="font-semibold text-base">
                                {submissionBoardModel.title}
                              </div>
                            </div>
                            {((submissionBoardModel?.episode_name ?? '') != '' ||
                              (submissionBoardModel?.scene_name ?? '') != '') && (
                                <div>
                                  <div className="pt-2 font-normal text-xs">Scene/Episode</div>
                                  <div className="font-semibold text-base">
                                    {submissionBoardModel?.episode_name
                                      ? submissionBoardModel.episode_name + ' / '
                                      : ''}
                                    {submissionBoardModel?.scene_name ?? ''}
                                  </div>
                                </div>
                              )}

                            <div>
                              <div className="pt-2 font-normal text-xs">Project</div>
                              <div className="font-semibold text-base">{project.title}</div>
                            </div>
                          </div>
                        </div>
                        <div className="flex flex-col gap-5">
                          <div className="text-2xl font-semibold text-left">
                            <span>Requirements</span>
                          </div>
                          <div className="flex flex-col gap-5 py-7 pr-7 pl-5 bg-gray-50 border-gray-400 text-sm text-gray-700 rounded-lg overflow-y-auto h-80 border rounded-lg">
                            <div className="font-medium text-gray-700 whitespace-pre-wrap">
                              {selectedSubmissionBoard?.requirements}
                              {/* <div
                            dangerouslySetInnerHTML={{
                              __html:
                                selectedSubmissionBoard?.requirements?.body ||
                                'No requirements specified',
                            }}
                          /> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            )}
            {false && (
              <div className="flex w-full flex-col px-2">
                <SbDetailCard
                  indexRow={indexRow}
                  fromScreen={fromScreen}
                  project={project}
                  submissionBoardModel={selectedSubmissionBoard}
                  refreshSubmissionBoard={() => {
                    if (refreshSubmissionBoard) {
                      refreshSubmissionBoard();
                    }
                  }}
                  editSb={function (index: number): void {
                    if (editSb) {
                      editSb(indexRow);
                    }
                  }}
                  submitForReview={submitForReviewClickHandler}
                  isSbClosed={isSbLocked}
                ></SbDetailCard>

                <div className="scrollable-content overflow-visible justify-items-center ">
                  <div className="flex w-full flex-col p-0 sm:p-2 ">
                    {/* <%# profiles start %> */}
                    <div className="flex gap-6 ">
                      {/* 🔹 User Guide Card (sidebar) */}
                      <div
                        className="w-full sm:w-1/4 flex-col flex shrink-0 gap-10"
                        style={{
                          maxWidth: '13.75rem',
                        }}
                      >
                        <div className="flex flex-col sm:flex-col border-b  gap-1 justify-between items-center">
                          <div className="text-base font-semibold  text-left h-20 justify-start items-center flex w-full">
                            <span>Board Notes</span>
                          </div>
                          <div className="flex flex-col gap-5 py-7 pr-7 pl-5 bg-heart-of-ice border-l-8 border-blue-400 text-sm text-black-600 border rounded-lg">
                            <div>{getSBCreatorName()}</div>
                            <div>
                              <div className="font-normal text-xs">Role</div>
                              <div className="font-semibold text-base">
                                {submissionBoardModel.title}
                              </div>
                            </div>
                            {((submissionBoardModel?.episode_name ?? '') != '' ||
                              (submissionBoardModel?.scene_name ?? '') != '') && (
                                <div>
                                  <div className="pt-2 font-normal text-xs">Scene/Episode</div>
                                  <div className="font-semibold text-base">
                                    {submissionBoardModel?.episode_name
                                      ? submissionBoardModel.episode_name + ' / '
                                      : ''}
                                    {submissionBoardModel?.scene_name ?? ''}
                                  </div>
                                </div>
                              )}

                            <div>
                              <div className="pt-2 font-normal text-xs">Project</div>
                              <div className="font-semibold text-base">{project.title}</div>
                            </div>
                          </div>
                        </div>
                        <div className="flex gap-5 flex-col justify-between items-left">
                          <div className="text-base font-semibold">
                            <span>Requirements</span>
                          </div>
                          <div className="text-sm">
                            <div className="break-words font-mono overflow-y-auto whitespace-pre-wrap">
                              {selectedSubmissionBoard?.requirements}
                              {/* <div
                            dangerouslySetInnerHTML={{
                              __html:
                                selectedSubmissionBoard?.requirements?.body ||
                                'No requirements specified',
                            }}
                          /> */}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="w-full sm:w-3/4 gap-7 flex flex-col">
                        <div className="flex flex-col sm:flex-row border-b  gap-2 justify-between items-center h-20">
                          <div className="text-base font-semibold">Shortlisted Profiles</div>
                          <div className="flex flex-1 items-center gap-2-1 pr-5 justify-end">
                            {!isSbLocked && fromScreen == fromRole.SB_CREATOR && (
                              <div className='className="flex flex-1 justify-end items-center gap-2-1pr-2-1 border-r border-gray-200"'>
                                <div className="flex items-center justify-end gap-2-1">
                                  <div className="text-sm font-normal">Add Talent:</div>
                                  <Button
                                    id="addmore_profiles_sb_btn_id"
                                    variant="secondary"
                                    btn_size="small"
                                    className="cursor-pointer"
                                    onClick={() => {
                                      addMoreProfilsClickHandler();
                                    }}
                                  >
                                    From Filmik
                                  </Button>
                                  <Button
                                    id="invite_profile_sb_btn_id"
                                    variant="secondary"
                                    btn_size="small"
                                    className="cursor-pointer"
                                    onClick={() => {
                                      invitePerformerClickHandler();
                                    }}
                                  >
                                    Invite New
                                  </Button>
                                </div>
                              </div>
                            )}
                            {/* View Toggle Buttons */}
                            <div className="flex items-center gap-2-1">
                              <Button
                                id="layout_grid_id"
                                variant="secondary"
                                btn_size="small"
                                className={`${viewMode === 'grid'
                                  ? 'bg-indigo-50 text-blue-500'
                                  : 'text-gray-600 hover:text-black'
                                  }`}
                                onClick={() => {
                                  setViewMode('grid');
                                }}
                              >
                                <div className="w-6 h-6 p-3px flex items-center justify-center">
                                  <LayoutGridIcon className="w-4-2 h-4-2" aria-hidden="true" />
                                </div>
                              </Button>
                              {/* <button
                            onClick={() => setViewMode('grid')}
                            className={`flex items-center gap-1 px-2 py-2 text-xs border rounded ${
                              viewMode === 'grid'
                                ? 'bg-indigo-50 text-blue-500'
                                : 'text-gray-600 hover:text-black'
                            }`}
                          >
                            <Squares2X2Icon className="h-4 w-4" />
                          </button> */}
                              <Button
                                id="layout_list_id"
                                variant="secondary"
                                btn_size="small"
                                className={`${viewMode === 'list'
                                  ? 'bg-indigo-50 text-blue-500'
                                  : 'text-gray-600 hover:text-black'
                                  }`}
                                onClick={() => {
                                  setViewMode('list');
                                }}
                              >
                                <div className="w-6 h-6 p-3px flex items-center justify-center">
                                  <LayoutListIcon className="w-4-2 h-4-2" aria-hidden="true" />
                                </div>
                              </Button>

                              {/* <button
                            onClick={() => setViewMode('list')}
                            className={`flex items-center gap-1 px-2 py-2 text-xs border rounded ${
                              viewMode === 'list'
                                ? 'bg-indigo-50 text-blue-500'
                                : 'text-gray-600 hover:text-black'
                            }`}
                          >
                            <ListBulletIcon className="h-4 w-4" />
                          </button> */}
                            </div>
                          </div>
                        </div>
                        {/* <hr className="mt-4 mb-4" /> */}

                        <div
                          ref={sortableRef}
                          className={
                            viewMode === 'grid'
                              ? (is400_639Screen ? 'px-0' : 'p-0') +
                              ' flex flex-col w-full sm:w-auto sm:grid sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-5'
                              : 'flex flex-col gap-5 w-full'
                          }
                          id="list_active"
                        >
                          {selectedSubmissionBoard != null &&
                            selectedSubmissionBoard.profiles.map((profileUser, index) => {
                              return (
                                <div
                                  key={profileUser.id}
                                  className="relative w-full"
                                >
                                  <SbProfileListItem
                                    currentUser={currentUser}
                                    submissionBoardModel={selectedSubmissionBoard}
                                    // key_token={key_token}
                                    // otp_valid={otp_valid}
                                    project={project}
                                    profileUser={profileUser}
                                    fromScreen={fromScreen}
                                    sb_recipient={sb_recipient}
                                    viewMode={viewMode}
                                    // showProfileDetailInModal={showProfileDetails}
                                    refreshSubmissionBoard={() => {
                                      if (refreshSubmissionBoard) {
                                        refreshSubmissionBoard();
                                      }
                                    }}
                                    updateSubmissionBoardCounts={updateSubmissionBoardCounts}
                                    // profileRemoved={(submissionBoardModel: any, userProfile: any) => {
                                    //   if (profileRemoved) {
                                    //     profileRemoved(submissionBoardModel, userProfile);
                                    //   }
                                    // }}
                                    profileIndex={index}
                                    prevNextProfile={(value: number, profileIndex: number) => {
                                      if (value == -1 && profileIndex - 1 >= 0) {
                                        setCurrentProfileIndex(profileIndex - 1);
                                      } else if (
                                        value == 1 &&
                                        profileIndex + 1 < selectedSubmissionBoard.profiles.length
                                      ) {
                                        setCurrentProfileIndex(profileIndex + 1);
                                      } else if (value == 0) {
                                        if (profileIndex == currentProfileIndex) {
                                          if (
                                            selectedSubmissionBoard != null &&
                                            currentProfileIndex != null
                                          ) {
                                            setShowProfileDetails(
                                              selectedSubmissionBoard.profiles[currentProfileIndex]
                                            );
                                          }
                                        } else {
                                          setCurrentProfileIndex(profileIndex);
                                        }
                                      }
                                    }}
                                  />
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    </div>
                    {/* <%# profiles end %> */}
                  </div>
                </div>
              </div>
            )}
          </>
        )}
        {showProfileDetails != null && (
          <SbProfileDetail
            currentUser={currentUser}
            project={project}
            submissionBoardModel={selectedSubmissionBoard}
            profileUser={showProfileDetails}
            fromScreen={fromScreen}
            sb_recipient={sb_recipient}
            // key_token={key_token}
            // otp_valid={otp_valid}
            dialogCloseHandler={() => {
              setShowProfileDetails(null);
            }}
            refreshSubmissionBoard={() => {
              if (refreshSubmissionBoard) {
                refreshSubmissionBoard();
              }
            }}
            prevNextProfile={async (value: number) => {
              if (value == -1 && currentProfileIndex - 1 >= 0) {
                setCurrentProfileIndex(currentProfileIndex - 1);
                return true;
              } else if (
                value == 1 &&
                currentProfileIndex + 1 < selectedSubmissionBoard.profiles.length
              ) {
                setCurrentProfileIndex(currentProfileIndex + 1);
                return true;
              } else if (value == 0) {
              }
              return false;
            }}
          ></SbProfileDetail>
        )}
        {addMoreProfiles && fromScreen == fromRole.SB_CREATOR && (
          <AllProfiles
            // key={`all-profiles-${selectedSubmissionBoard?.profiles?.length || 0}`}
            currentUser={currentUser}
            project={project}
            submissionBoardModel={selectedSubmissionBoard}
            dialogCloseHandler={() => {
              if (refreshSubmissionBoard) {
                refreshSubmissionBoard();
              }
              setAddMoreProfiles(false);
            }}
            profileSelected={async (profileInfo: any) => {
              // Update counts directly when profile is added
              if (updateSubmissionBoardCounts) {
                updateSubmissionBoardCounts(selectedSubmissionBoard.id, {
                  type: 'add',
                });
              }
              // if (refreshSubmissionBoard) {
              //   refreshSubmissionBoard();
              // }
            }}
          ></AllProfiles>
        )}
        {showInvitePerformer && fromScreen == fromRole.SB_CREATOR && (
          <InvitePerformer
            currentUser={currentUser}
            project={project}
            submissionBoardModel={selectedSubmissionBoard}
            dialogCloseHandler={() => {
              setShowInvitePerformer(false);
            }}
          ></InvitePerformer>
        )}
      </div>
    </>
  );
}
